import { Collapse, Button, Tooltip } from 'antd'
import { useRef, useState } from 'react'
import { EditOutlined, UndoOutlined, CaretRightOutlined, PhoneOutlined } from '@ant-design/icons'
import { URL_TEMPLATE, configNumberStudent } from 'src/libs/constant'
import EnterClassInButton from '../button/EnterClassInButton'
import { MaterialButton, MaterialModal } from '../../class/Material'
import { SCHEDULE_TYPE } from 'src/libs/constant/calendar'

export function CollapseBlock ({
  titleMaterials,
  classData,
  header,
  editable,
  setEditable,
  children,
  phone,
  onUndo,
  ButtonHeaderComponent,
  isShowButton,
  isTooltip = false,
  ...rest
}) {
  const collapseRef = useRef(true)
  const { pathname } = window.location
  const { canViewMaterial = false } = rest || {}
  const { status = null, folderId } = classData || {}
  const [isModalVisible, setIsModalVisible] = useState(false)
  const handleClickEditable = (event) => {
    if (collapseRef.current) {
      event.stopPropagation()
    }
    setEditable(true)
  }
  const handleClickUndo = (event) => {
    if (collapseRef.current) {
      event.stopPropagation()
    }
    onUndo && onUndo()
    setEditable(false)
  }

  return (
    <>
      <Collapse
        defaultActiveKey={['1']}
        onChange={() => { collapseRef.current = !collapseRef.current }}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
        className='mb-2'
      >
        <Collapse.Panel
          key='1'
          header={header}
          extra={
            <div className='d-flex' style={{ gap: '8px' }}>
              {isShowButton && <ButtonHeaderComponent />}
              {
                canViewMaterial && classData && ['BOOKED', 'DONE', 'DONE_1', 'DONE_2'].includes(status) &&
                <span className='mr-2'>
                  <MaterialButton onClick={() => setIsModalVisible(true)} title={titleMaterials} />
                </span>
              }
              {
                pathname != URL_TEMPLATE.SESSION_TEACHING_DETAIL && classData && (
                  // <span className='mr-2'>
                  <EnterClassInButton
                    sessionId={classData?.id}
                    sessionStatus={classData?.status}
                    classTimeSlotId={classData?.classTimeSlotId}
                    learnDate={classData?.learnDate}
                    teacherId={classData?.teacherId}
                    sessionType={classData?.scheduleType === SCHEDULE_TYPE.DEMO ? SCHEDULE_TYPE.DEMO : SCHEDULE_TYPE.REGULAR}
                  />
                  // </span>
                )
              }
              {
                phone && <a href={`${configNumberStudent}${phone}`}>
                  <Button
                    className='d-flex justify-content-center align-items-center mr-1'
                    icon={<PhoneOutlined />}
                    onClick={(event) => {
                      if (collapseRef.current) {
                        event.stopPropagation()
                      }
                    }}
                  >
                  </Button>
                </a>
              }
              {
                setEditable &&
                (
                  <>
              {isTooltip ? (
                <Tooltip
                  placement='topRight'
                  color='#fff'
                  title={!editable ? 'Chỉnh sửa' : 'Huỷ bỏ'}
                  overlayInnerStyle={{ color: '#111827' }}
                  key='edit'
                >
                  <Button
                    className='text-secondary d-flex justify-content-center align-items-center border-0'
                    icon={!editable ? <EditOutlined /> : <UndoOutlined />}
                    onClick={!editable ? handleClickEditable : handleClickUndo}
                    style={{ fontSize: 14 }}
                    shape='circle'
                    ghost
                  />
                </Tooltip>
              ) : (
                <Button
                  className='text-secondary d-flex justify-content-center align-items-center border-0'
                  icon={!editable ? <EditOutlined /> : <UndoOutlined />}
                  onClick={!editable ? handleClickEditable : handleClickUndo}
                  style={{ fontSize: 14 }}
                  shape='circle'
                  ghost
                />
              )}
                  </>
                )
              }
            </div>
          }
          {...rest}
        >
          {children}
        </Collapse.Panel>
      </Collapse>
      <MaterialModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        folderId={folderId}
      />
    </>
  )
}
